import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Favorite } from './Favorite';

export const FavoriteCharacter = inject('me')(
  observer(({ me, characterId, size, className }) => (
    <Favorite
      size={size}
      className={className}
      checked={me.isFavorite('characters', characterId)}
      onCheck={(checked) => me.setFavorite('characters', characterId, checked)}
    />
  ))
);

FavoriteCharacter.propTypes = {
  characterId: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};
